document.documentElement.classList.add("has-js");

const initReveals = () => {
  const revealTargets = document.querySelectorAll("[data-reveal], [data-image-reveal]");

  if (!("IntersectionObserver" in window)) {
    revealTargets.forEach((target) => target.classList.add("is-visible"));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: "0px 0px -10% 0px",
      threshold: 0.08,
    }
  );

  revealTargets.forEach((target) => observer.observe(target));
};

window.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add("is-ready");
  initReveals();
});
